import { FeatureType } from '@shared/interfaces/feedback';
import { FeedbackFormData } from '../../components/feedback-form/feedback-types';
import { slurryFormData } from '../../pages/slurry-optimization-page/feedback';
import { osmFormData } from '../../pages/osm-page/feedback';
import { soilCompactionFormData } from '../../pages/soil-compaction-page/feedback';
import { schedulingFormData } from '../../pages/scheduling-page/feedback';
import { guidanceFormData } from '../../pages/guidance-page/feedback';
import { wildOatsMappingFormData } from '../../pages/wild-oats-mapping/feedback';
import { generalFormData } from '../../components/feedback-fab/components/general-feedback/feedback';

const dummy = { id: 'feature-not-specified' as FeatureType, title: 'dummy', subtitle: 'dummy', questions: [] };
export const featureToFormDataMap: { [key in FeatureType]: FeedbackFormData } = {
  general: generalFormData,
  'slurry-optimization': slurryFormData,
  'soil-compaction': soilCompactionFormData,
  'public-landscape-objects': osmFormData,
  scheduling: schedulingFormData,
  'guidance-data-converter': guidanceFormData,
  osm: dummy,
  guidance: dummy,
  'wild-oats-mapping': wildOatsMappingFormData,
  'feature-not-specified': dummy,
};
export const radioDefaultValues = [
  { id: 'strongly-agree', label: $localize`Strongly agree` },
  { id: 'agree', label: $localize`Agree` },
  { id: 'neither', label: $localize`Neither agree nor disagree` },
  { id: 'disagree', label: $localize`Disagree` },
  { id: 'strongly-disagree', label: $localize`Strongly disagree` },
];
export const wildcardId = 'wildcard:';
